/*
 * Module for the Permissions SelectTrustees page
 */
rs.module("content/security/administration/permissions/selecttrustees",

    [],

    function () {

        // initialize the module
        function initialize(jsSelectors, trusteesGridLrsApi) {

            // TODO: This can be removed if/when we implement the changes detailed in Task 122483 / item #24 of Task 116160
            _configureGridSelection();

            // js selectors
            var addSelectedButton = $.js(jsSelectors.addSelectedButton);

            // Disable the AddSelected button if nothing is selected
            trusteesGridLrsApi.selectionChanged(function (values, rows) {
                addSelectedButton.prop("disabled", values[0] == null);
            });

            // show disabled checkboxes in the leftmost column & set selectable
            function _configureGridSelection() {

                // Loop through the grid's nodes and mark InGroup nodes as unselectable
                trusteesGridLrsApi.agGridApi.forEachNode((node) => node.selectable = !node.data.IsInGroup);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);